module.exports = __webpack_public_path__ + "img/option.38ad8d44.svg";